﻿import React from "react";
import { observer } from "mobx-react";
import type { IUploadStore } from "../../../UploadStore";
import { injectFromAppUpload } from "../../../inject";
import type { FileUpload } from "../../../FileUpload";
import { ParagraphRichToolTipComponent, RichToolTipComponent } from "../../../../shared-components/rich-tooltip/RichToolTipComponent";
import { humanizeFileSize } from "../../../../util/functions/humanizeFileSize";

interface INonDicomFileComponent {
    uploadStore?: IUploadStore;
    file: FileUpload;
    canBeRemoved: boolean;
}

@injectFromAppUpload<INonDicomFileComponent>(stores => ({
    uploadStore: stores.uploadStore,
}))
@observer
export class NonDicomFileComponent extends React.Component<INonDicomFileComponent> {
    private readonly removeFile = (event): void => {
        const { uploadStore, file } = this.props;
        event.stopPropagation();
        uploadStore!.removeFileUpload(file);
    };

    render() {
        const { file, canBeRemoved } = this.props;
        const { selected, selectable, size, name } = file;

        return (
            <div className={"file-to-arrange" + (selectable ? " selectable" : "") + (selected ? " selected" : "")} onClick={() => file.setSelected(!selected)}>
                <ParagraphRichToolTipComponent toolTipDelay={700} toolTipContent={name} className={"file-name"}>
                    {name}
                </ParagraphRichToolTipComponent>
                <p className={"file-size"}>{humanizeFileSize(size)}</p>
                {canBeRemoved && (
                    <RichToolTipComponent toolTipResource={"RemoveFile"} className={"remove-file"} onClick={this.removeFile}>
                        &nbsp;
                    </RichToolTipComponent>
                )}
            </div>
        );
    }
}
